var React = require('react');

function TriangleBottomDesktop (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M84.203 86.7614L73.5323 23.0415L160.279 74.6375L84.203 86.7614Z","fill":"#6C21E4","key":0}),React.createElement("path",{"d":"M34.4053 124.085L73.6194 22.976L84.247 86.6208L34.4053 124.085Z","fill":"#651DD8","key":1}),React.createElement("path",{"d":"M34.4102 124.085L84.2167 86.6468L160.287 74.6351L34.4102 124.085Z","fill":"#5915C7","key":2})]);
}

TriangleBottomDesktop.defaultProps = {"width":"161","height":"153","viewBox":"0 0 161 153","fill":"none"};

module.exports = TriangleBottomDesktop;

TriangleBottomDesktop.default = TriangleBottomDesktop;
